// extracted by mini-css-extract-plugin
module.exports = {"main-image":"style_main-image__XbwDT","swiper":"style_swiper__zX4Y8"};